import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>Dashboard</title>
		</Helmet>
	)
}

export default Head
